import { useQuery, UseQueryResult } from 'react-query';
import { DocumentRetrieve } from 'types';
import { client } from 'utils/api-client';

function useDocument(documentId: string | undefined | null): UseQueryResult<{ data: DocumentRetrieve }> {
  return useQuery(['documents', documentId], () => client.get(`documents/${documentId}/`), {
    enabled: !!documentId,
  });
}

export default useDocument;
